import { connect } from 'react-redux'
import { pageToggleLeft } from 'redux/actions'
import LeftDrawerWrapper from 'components/layout/LeftDrawerWrapper'

const mapStateToProps = state => ({
  controller: state.layout.controller,
  windowHeight: state.layout.windowHeight,
  isLargeDesktop: state.layout.deviceType.isLargeDesktop,
  windowWidth: state.layout.windowWidth,
  headerHeight: state.layout.headerHeight,
  deviceType: state.layout.deviceType
})

const mapDispatchToProps = dispatch => ({
  pageToggleLeft: force => dispatch(pageToggleLeft(force))
})

export default connect(mapStateToProps, mapDispatchToProps)(LeftDrawerWrapper)
